// extracted by mini-css-extract-plugin
export default {"QV":"tagcgcF8qKjJM93IvL7g"};